import React from "react";
import logoHeader from "../../assets/logo_header_e4p.png";
import { useMediaQuery } from "react-responsive";
export default function Menu() {
  const isMobile = useMediaQuery({ query: `(max-width: 660px)` });
  // dependant on screen size will display different text on button //
  const buttonContent = isMobile ? "Register" : "Register on Carrier Directory";
  return (
    <nav className="menu">
      <a href="https://www.easy4pro.com">
        <img src={logoHeader} alt="Easy4Pro Logo" className="logo-header" />
      </a>
      <a href="https://forms.zohopublic.eu/easy4pro/form/E4PCarrierDirectoryfree1/formperma/Z8SujMA-T7sC6YZoE60_uvIpLCtdo42soZOiFfHwM3s"
      target="_blank" rel="noreferrer">
        <button className="register-button">{buttonContent}</button>
      </a>
    </nav>
  );
}
